<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>

        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="fullPage">
            </loading>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </b-col>
                    <b-col cols="4">
                       <base-button type="success" @click="newSaleDocument" class="float-right">
                          <i class="fa fa-plus"></i>
                          {{language_terms['NEW']}}
                          {{type == 'SALES' ? language_terms['SALES_RECEIPTS'] : language_terms['PURCHASE_RECEIPTS']}}
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="4" >
                    <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch">
                    </base-input>
                  </b-col>
                  <b-col md="3" >
                    <base-input :label="language_terms['DATE_FROM']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.from_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input :label="language_terms['DATE_TO']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.to_date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <!-- <b-col md="2">
                    <base-input label="Sales Type">
                      <el-select v-model="filter.type" filterable>
                        <el-option v-for="option in sales_types"
                                  :key="option.value"
                                  :label="option.label"
                                  :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col> -->
                  <b-col cols="1" class="mt-4">
                    <base-button type="primary" @click="clickOnSearch" class="mt-2">{{language_terms['SEARCH']}}</base-button>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col cols="12">
                    <base-button type="primary" @click="clickOnSearch">{{language_terms['SEARCH']}}</base-button>
                  </b-col>
                </b-row> -->
              </card>
              <!-- Search Results -->
              <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>
            </div>
          </b-col>
        </b-row>
        <!-- <a href="javascript:void(0)" class="float" @click="newSaleDocument">
          <i class="fa fa-plus my-float"></i>
        </a> -->
      </b-container>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  props:
  {
        type: {
          type: String,
          default: 'SALES',
          description: 'Type',
          required:true
        },
        addNew: {
          type: String,
          default: 'Add New Sale Document',
          description: 'Add New Sale Document',
          required:true
        },
  },
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
      computed:{
      ...mapState({
        receipt_filter:state => state.receipts.filter,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        receipts: state => state.receipts.sales_receipts

      }),
    },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
      receipts: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        console.log("A")
        this.items = this.receipts
      }
    }
  },
  async mounted()
  {
      // console.log(this.type)
      if(this.type == 'SALES')
      {
          this.items = this.receipts
      }

      this.updateTableLang()

      if(this.receipt_filter)
      {
        this.filter = this.receipt_filter
      }
  },
  data(){
    return{
      fullPage:true,
      loading:false,
      filter:{
        keyword:"",
        date_from:null,
        date_to:null,
        type:null,
        status:'ALL'
      },
      items:[],
      tableColumns: [
            {
              prop: 'code',
              label: 'Document#',
              minWidth: 135,
              sortable: true,
              key:'CODE'

            },
            {
              prop: 'contact_name',
              label: 'Customer',
              minWidth: 180,
              sortable: true,
              key:'CUSTOMER'

            },
            {
              prop: 'date',
              label: 'Date',
              minWidth: 120,
              sortable: true,
              key:'DATE'

            },
            {
              prop: 'mode',
              label: 'Payment Mode',
              minWidth: 130,
              sortable: true,
              key:'PAYMENT_MODE'

            },
            {
              prop: 'reference',
              label: 'Reference',
              minWidth: 130,
              sortable: true,
              key:'REFERENCE'
            },
            {
              prop: 'amount',
              label: 'Amount',
              minWidth: 130,
              sortable: true,
              key:'AMOUNT'
            },
            {
              prop: 'is_void',
              label: 'Void',
              minWidth: 140,
              sortable: true,
              key:'IS_VOID'

            },
        ],

    }
  },

  methods:{
     updateTableLang(){
      for(let i=0; i < this.tableColumns.length;i++)
      {
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    },
    async clickOnSearch(){
      this.filter.type = this.type
      this.loading = true
      await this.$store.dispatch("receipts/quickSearch", this.filter);
      this.loading = false
    },
    clickOnReset(){
      this.filter = {
          keyword:"",
          date_from:null,
          date_to:null,
          type:'SQ',
          status:'ALL'
      }
    },
    async newSaleDocument(){
       this.$router.push(this.$props.addNew+"_new")
    }
  }
}
</script>
